import React, { Component } from 'react'
import {Container} from 'react-grid-system'

// STYLES
import styled from 'styled-components'

// COMPONENTS
import Title from '../../components/title/title.component'
import SubTitle from '../../components/subtitle/subtitle.component'
import Button from '../../components/button/button.component'

import Slider from '../../components/slider/slider'
import Data from '../../assets/data/data.json'

export default class Tabs extends Component {
  constructor () {
    super()
    this.state = {
      data: ''
    }
  }

  render () {
    const { t, i18n } = this.props
    return (
      <EventsHeader id='qualification'>
        <Container>
          <Title color={'#2E84C6'} text={t('Quali_Title')} />
          <JoinText>
            <p>{t('Quali_Frase1')}</p>
            <p>{t('Quali_Frase2')}</p>
            <p>{t('Quali_Frase3')}</p>
          </JoinText>
          <ButtonAlign>
            <a href='https://ahresp.com/o-associado/formacao-em-gestao-alojamento-local/' target='_black'>
              <Button bgColor={'#2E84C6'} color='#FFF' size='sm' text={t('Inscreva-se aqui')} />
            </a>
          </ButtonAlign>
          <SubTitle color={'#2E84C6'} text={t('Quali_Frase4')} />
        </Container>
        <TabsWrapper>
          <TabsContent>
            <Container>
              <Slider
                lang={window.localStorage.getItem('i18next_Lng')}
                data={Data}
                i18n={i18n}
              />

              <Info>* {t('Quali_Frase5')}</Info>

            </Container>
          </TabsContent>
        </TabsWrapper>

      </EventsHeader>
    )
  }
}

const EventsHeader = styled.div`
    width: 100%;
    background-color: #FFF;
    padding-top: 90px;
`
const TabsWrapper = styled.div`
`
const TabsContent = styled.div`
    padding-top: 35px;
    padding-bottom: 30px;
    background-color: rgba(15,143,202,0.1);

`
const JoinText = styled.div`
    max-width: 700px;
    color: #5C5A5A;
    font-family: "Source Sans Pro";
    font-size: 18px;
    line-height: 23px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;

    @media screen and (max-width: 767px) {
        text-align: center;
    }
`
const Info = styled.div`
    color: #2E84C6;
    font-family: "Source Sans Pro";
    font-size: 16px;
    margin-top: 20px;
    text-align: center;
`
const ButtonAlign = styled.div`
    text-align: center!important;
    margin-right: auto;
    margin-left: auto;
    margin-top: 20px;
    margin-bottom: 30px;
`



// WEBPACK FOOTER //
// ./src/sections/tabs/tabs.section.js